import { useState } from "react";
import { Calendar as CalendarIcon, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { format, parseISO } from "date-fns";

export default function DayPicker({ value, onChange, days }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value + "T00:00:00") : new Date();
  const savedSet = new Set((days || []).map((d) => d.date));

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="border-[#e2e8f0] bg-white hover:bg-[#f1f5f9] font-mono"
          data-testid="day-picker-trigger"
        >
          <CalendarIcon className="w-4 h-4 mr-2 text-[#0284c7]" />
          {format(date, "MMM d, yyyy")}
          <ChevronDown className="w-3.5 h-3.5 ml-2 opacity-60" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border-[#e2e8f0]" align="end">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (d) {
              const iso = d.toISOString().slice(0, 10);
              onChange(iso);
              setOpen(false);
            }
          }}
          modifiers={{
            saved: (d) => savedSet.has(d.toISOString().slice(0, 10)),
          }}
          modifiersClassNames={{
            saved: "relative after:content-[''] after:w-1 after:h-1 after:rounded-full after:bg-[#0284c7] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2",
          }}
          className="p-3"
        />
      </PopoverContent>
    </Popover>
  );
}
